<template>
  <FormContainer without-divider>
    <template #title>Établissement</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_2"
          :model-value="model?.employeur?.etablissement?.denomination"
          label="Raison Sociale"
          class="col-22 col-sm-36"
          :required="meta.employeur?.etablissement?.denomination?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.denomination?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_unknown"
          :model-value="model?.employeur?.etablissement?.siret?.valeur"
          label="Siret de l'établissement d'exécution du contrat"
          class="col-14 col-sm-36"
          :required="meta.employeur?.etablissement?.siret?.valeur?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.siret?.valeur?.$messageErreurDirty!"
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_unknown"
          :model-value="model?.employeur?.etablissement?.naf?.code"
          label="NAF"
          class="col-6 col-md-10 col-sm-36"
          :required="meta.employeur?.etablissement?.naf?.code?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.naf?.code?.$messageErreurDirty!"
          disabled
        />

        <WrapperInput
          id="field_unknown"
          :model-value="model?.employeur?.etablissement?.idcc?.code"
          label="IDCC"
          class="col-6 col-md-10 col-sm-36"
          :required="meta.employeur?.etablissement?.idcc?.code?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.idcc?.code?.$messageErreurDirty!"
          disabled
        />

        <WrapperInput
          id="field_unknown"
          :model-value="model?.typePublic"
          label="Type de public"
          class="col-6 col-md-10 col-sm-36"
          disabled
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
import { useDemandePROAStore } from '@/features/interface/demande/proa/useDemandePROAStore'
import { FormContainer } from '@/features/interface/demande/shared'
import { storeToRefs } from 'pinia'

  const store = useDemandePROAStore()
  const { meta, model } = storeToRefs(store)

</script>
